(async () => {
  if (!customElements.get('login-recover')) {
    const { default: Cookies } = await import('js-cookie');

    class loginRecover extends HTMLElement {
      constructor() {
        super();
        // Remove current content value from local storage for a clean start
        localStorage.setItem("currentAccountContent", "");

        // Toggle password visibility
        const togglePassword = document.querySelector('#togglePassword');
        const password = document.querySelector('#CustomerPassword');

        togglePassword.addEventListener('click', function (e) {
          // toggle the type attribute
          const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
          password.setAttribute('type', type);
          // toggle the eye slash icon
          this.classList.toggle('show-password');
        });

        // Delay validation on email form field
        let interval;
        document.querySelector('#CustomerEmail').addEventListener('keydown', () => {
          clearInterval(interval)
          let el = event.target;
          el.classList.add('hide-invalid');
          interval = setTimeout(() => {
            el.classList.remove('hide-invalid');
          }, 2500);
        });

        document.querySelector('#RecoverEmail').addEventListener('keydown', () => {
          clearInterval(interval)
          let el = event.target;
          el.classList.add('hide-invalid');
          interval = setTimeout(() => {
            el.classList.remove('hide-invalid');
          }, 2500);
        });

        //Cookie for password recovery form
        // cookie states at loading
        this.RecoveryCookie = Cookies.get('recovery') ? true : false;
        this.login = document.querySelector('[data-login]');
        this.submit_recovery_btn = document.querySelector("[data-recover]");

        if (this.login) {
          //Remove cookie on login
          this.login.addEventListener('click', () => {
            Cookies.remove('recovery');
          });
        }

        if (this.submit_recovery_btn) {
          //Add cookie on submit recovery form
          this.submit_recovery_btn.addEventListener('click', () => {
            Cookies.set('recovery', 'true', { expires: 1 });
          });
        }

        window.addEventListener('load', () => {
          const RecoveryCookie = Cookies.get('recovery') ? true : false;
          const RecoverySucces = document.querySelector('[data-recover_success]');

          // If cookie is true on page load and recovery wasn't succeeded, show message and remove cookie
          if (RecoveryCookie && !RecoverySucces) {
            document.querySelector('[data-recover_message]').classList.remove('hidden');
            Cookies.remove('recovery');
          }
        });
      }
    }
    window.loginRecover = loginRecover;
    customElements.define('login-recover', loginRecover);
  }
})();